import React, { useEffect, useState } from "react";
import Loader from "../../../../components/loader/loader";
import CustomTable from "../../../../components/table/table";
import ManageTender from "./manage/manage";
import ConfirmDialog from "../../../../components/actionDialogs/confirmDialog";
import ReactHtmlParser from "react-html-parser";
import Snackbar from "../../../../components/snackbar/snackbar";
import {
  admin_tender_list,
  admin_tender_delete,
  tech_tender_cat_data,
  tech_tender_org_data,
} from "../../admin.api";
import "./view.css";
import jwtDecode from "jwt-decode";
import moment from "moment";
import * as XLSX from "xlsx";
export default function View(props) {
  let adminType = Number(jwtDecode(props.state.payload).user_type);
  const [data, setdata] = useState([]);
  const [addNew, setAddNew] = useState(false);
  const [formData, setFormData] = useState({});
  const [edit, setEdit] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [openAction, setOpenAction] = useState(false);
  const [activeData, setActiveData] = useState({});
  const [view, setView] = useState(false);
  const [dropcatdata, setDropcatdata] = useState([]);
  const [droporgdata, setDroporgdata] = useState([]);

  const [isActive, setIsActive] = useState(true);
  const [fileError, setFileError] = useState(false);
  const handleEventList = () => {
    setIsActive(true);
    admin_tender_list().then((res) => {
      let tempData = res?.data;

      if (tempData) {
        tempData = tempData.filter((item) => item?.type === "public");
        tempData.forEach((item, index) => {
          item["slno"] = index + 1;
          if (item?.type && item?.type === "public") {
            item["public"] = 1;
          } else if (item?.type && item?.type === "private") {
            item["public"] = 0;
          }
          if (item?.due_date) {
            item["due_date"] = moment(
              item?.due_date,
              "YYYY-MM-DD HH:mm"
            ).format("DD-MM-YYYY HH:mm");
          }
        });
        setdata(tempData);
      }
      setIsActive(false);
    });
  };
  useEffect(() => {
    handleEventList();
  }, []);
  const getDropdownCatData = () => {
    tech_tender_cat_data()
      .then((res) => {
        setDropcatdata(res);
      })
      .catch((err) => {
        setSnackMessage(err.message);
        setIsSnackError(false);
        setSnackOpen(false);
      });
  };
  const handleClose = () => {
    setAddNew(false);
    setEdit(false);
    setFormData({});
    handleEventList();
  };
  const handleEdit = (data) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      ...data,
    }));
    setView(false);
    setEdit(true);
    setAddNew(true);
  };
  const handleAddNew = () => {
    const a = {
      public: 0,
      type: "private",
    };
    setFormData(a);
    setAddNew(true);
    setView(false);
  };
  const handleDelete = (data) => {
    setActiveData(data);
    setOpenAction(true);
  };
  const handleCancelDelete = () => {
    setOpenAction(false);
  };
  const handleDeleteConfirm = (data) => {
    setOpenAction(false);
    admin_tender_delete(data.uuid)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setSnackOpen(true);
      });
  };
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      handleEventList();
    }
  };
  const handleView = (data) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      ...data,
    }));

    setAddNew(true);
    setView(true);
  };
  async function fetchExportData() {
    const exportdata = [];
    data.forEach((item) => {
      exportdata.push({
        Name: `${item?.tender_title}`,
        // Type: item.type,
        Value: item?.value_of_tender,
        ["Due Date"]: item.due_date
          ? moment(item.due_date, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY")
          : "",
        // ["Organization"]: item.organisation?.name,
        // ["Category"]: item.category?.name,
        Status: item?.tender_publish_status == 1 ? "Active" : "Inactive",
        // Date: item.created_at
        //   ? moment(item.created_at).format("DD-MMM-YYYY hh:mm A")
        //   : "--",
        // Status:
        //   item.approval_status === 0
        //     ? "Pending"
        //     : item.approval_status === 1
        //     ? "Submitted"
        //     : item.approval_status === 2
        //     ? "Approved"
        //     : item.approval_status === 3
        //     ? "SA Reverted"
        //     : item.approval_status === 4
        //     ? "Rejected"
        //     : item.approval_status === 5
        //     ? "Reverted"
        //     : "",
      });
    });
    return exportdata;
  }
  const downloadExcel = async () => {
    const exportData = await fetchExportData();
    if (!exportData.length) {
      setSnackMessage("No data to export");
      setIsSnackError(true);
      setSnackOpen(true);
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Tender List");

    XLSX.writeFile(
      workbook,
      `Tender_list${moment().format("DD-MM-YYYY,HH-mm-ss")}.xlsx`
    );
  };
  return (
    <div>
      <Loader open={isActive} />
      <div className="view-container">
        {/* <h6>
          <b>Tender</b>
        </h6> */}
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="m-0">
            <b>Tender</b>
          </h6>
          <button
            className="px-2 py-2 search-style border-0 text-white rounded"
            onClick={downloadExcel}
          >
            Download Excel
          </button>
        </div>
        <hr />
        {adminType != 23 && (
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={(e) => handleAddNew(e)}
          >
            Add New
          </button>
        )}
        <CustomTable
          {...props}
          columns={[
            { title: " SL No", type: "dynId" },
            { title: " Tender Title", field: "tender_title" },
            {
              title: "Tender Description",
              field: "description",
              render: (rowData) => (
                <div>{ReactHtmlParser(rowData?.description)}</div>
              ),
            },
            { title: "Tender by", field: "organized_by" },
            { title: "Due Date", field: "due_date" },
          ]}
          data={data}
          actions={
            adminType === 2
              ? [
                  { type: "view", handleClick: handleView },
                  { type: "edit", handleClick: handleEdit },
                  { type: "delete", handleClick: handleDelete },
                ]
              : adminType === 1
              ? [
                  { type: "view", handleClick: handleView },
                  { type: "edit", handleClick: handleEdit },
                ]
              : [{ type: "view", handleClick: handleView }]
          }
        />
      </div>
      {addNew && (
        <ManageTender
          open={addNew}
          edit={edit}
          view={view}
          handleClose={handleClose}
          formData={formData}
          fileError={fileError}
          setFileError={setFileError}
          dropcatdata={dropcatdata}
          droporgdata={droporgdata}
        />
      )}
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      {openAction && (
        <ConfirmDialog
          open={openAction}
          title="Delete Tender ?"
          data={activeData}
          message="Are you sure to delete this Tender?"
          secondary_action="Cancel"
          primary_action="Delete"
          handleClose={handleCancelDelete}
          handleConfirm={handleDeleteConfirm}
        />
      )}
    </div>
  );
}
